import React from 'react';
import PropTypes from 'prop-types';

import './DarkScreenMask.scss';

const DarkScreenMask = ({ children, isVisible })=> {
  return (
    <div className="dark-screen-mask" 
      style={{ 
        visibility: isVisible ? "visible" : "hidden",
        opacity: isVisible ? 1 : 0 
      }}>
      {children}
    </div>
  );
};

DarkScreenMask.propTypes = {
  children: PropTypes.any, // eslint-disable-line
  isVisible: PropTypes.bool
};

DarkScreenMask.defaultProps = {
  children: null,
  isVisible: false
}

export default DarkScreenMask;